export default __webpack_public_path__ + "static/media/star_circle.32ec6b79.svg";